import { apiRequest } from "./httpClient.js"

/**
 * Catalogo dinamico consumido por el formulario de creacion de servidores
 * (TODO.md "Crear servidores desde la app", ver services/gateway/src/
 * routes/serverCatalog.ts). Versiones de Minecraft (Mojang) y de loader
 * (Fabric/Quilt/Forge) se consultan en vivo en vez de vivir hardcodeadas
 * aca, para que una version nueva este disponible sin tocar codigo.
 */

export interface MinecraftVersionSummary {
  id: string
  type: "release" | "snapshot" | "old_beta" | "old_alpha"
  releaseTime: string
}

export function listMinecraftVersions(includeSnapshots = false): Promise<{ versions: MinecraftVersionSummary[] }> {
  const query = includeSnapshots ? "?includeSnapshots=true" : ""
  return apiRequest(`/api/v1/server-catalog/minecraft-versions${query}`)
}

/**
 * Versiones de Minecraft que un software concreto realmente soporta (Paper,
 * Purpur -- ver MinecraftVersionRestrictor en el Gateway). Para software sin
 * restrictor (fabric/forge/quilt/vanilla/otros) el Gateway devuelve el mismo
 * catalogo general que listMinecraftVersions -- se puede llamar esta funcion
 * siempre en vez de decidir del lado del cliente cual de las dos usar.
 */
export function listSoftwareVersions(software: string, includeSnapshots = false): Promise<{ versions: string[] }> {
  const query = includeSnapshots ? "?includeSnapshots=true" : ""
  return apiRequest(`/api/v1/server-catalog/software-versions/${encodeURIComponent(software)}${query}`)
}

export interface LoaderVersionSummary {
  version: string
  stable: boolean
}

/** `loader` es texto libre del lado del cliente (coincide con serverSoftware, ver CreateServerForm.tsx) -- el Gateway devuelve `versions: []` para un loader sin catalogo en vez de un error. */
export function listLoaderVersions(loader: string, minecraftVersion: string): Promise<{ versions: LoaderVersionSummary[] }> {
  return apiRequest(`/api/v1/server-catalog/loader-versions/${encodeURIComponent(loader)}?minecraftVersion=${encodeURIComponent(minecraftVersion)}`)
}

/**
 * Refresh manual (TODO.md, pedido explicito de Joanfer): invalida el cache
 * de todos los catalogos del lado del Gateway, para el caso de "salio una
 * version hoy y no quiero esperar el TTL de 10 minutos". Solo host_owner
 * (mismo gate que el endpoint real).
 */
export function refreshServerCatalog(): Promise<void> {
  return apiRequest("/api/v1/server-catalog/refresh", { method: "POST" })
}
